import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ApiDocsAccessContextType {
  hasAccess: boolean;
  authenticate: (password: string) => boolean;
  logout: () => void;
}

const ApiDocsAccessContext = createContext<ApiDocsAccessContextType | undefined>(undefined);

// Hard-coded password for API docs access
const API_DOCS_PASSWORD = 'LiquidCreditAPI2025!';
const STORAGE_KEY = 'liquidcredit_api_docs_access';

interface ApiDocsAccessProviderProps {
  children: ReactNode;
}

export const ApiDocsAccessProvider: React.FC<ApiDocsAccessProviderProps> = ({ children }) => {
  const [hasAccess, setHasAccess] = useState<boolean>(false);

  // Check for existing access on mount
  useEffect(() => {
    const storedAccess = localStorage.getItem(STORAGE_KEY);
    if (storedAccess === 'granted') {
      setHasAccess(true);
    }
  }, []);

  const authenticate = (password: string): boolean => {
    if (password === API_DOCS_PASSWORD) {
      setHasAccess(true);
      localStorage.setItem(STORAGE_KEY, 'granted');
      return true;
    }
    return false;
  };

  const logout = () => {
    setHasAccess(false);
    localStorage.removeItem(STORAGE_KEY);
  };

  const value: ApiDocsAccessContextType = {
    hasAccess,
    authenticate,
    logout,
  };

  return (
    <ApiDocsAccessContext.Provider value={value}>
      {children}
    </ApiDocsAccessContext.Provider>
  );
};

export const useApiDocsAccess = (): ApiDocsAccessContextType => {
  const context = useContext(ApiDocsAccessContext);
  if (context === undefined) {
    throw new Error('useApiDocsAccess must be used within an ApiDocsAccessProvider');
  }
  return context;
};
